import PhotoSwipe from './photoswipe';
import PhotoSwipeUI_Default from './photoswipe-ui-default';
import viewerTemplate from './viewer-template';
import viewerTemplateScroll from './viewer-template-scroll';
import './slick.js';
import './horizontalBox.js';

class Viewer {
    constructor(options) {
        this.photoswipe = null;
        this.slide = null;
        this.scroller = false;
        this.config = options;
        this.image = this.config.image;
        this.imageLength = this.image.length;
        this.imageLoaded = 0;
        this.nowIndex = 0;
        this.DOM_SLIDE = null;
        this.DOM_SLIDEBUTTON = null;
        this.scrollWidth = 0;

        this.items = [];

        window.galleryNum = window.galleryNum ? window.galleryNum + 1 : 1;

        this.uid = window.galleryNum;
        this.setTemplate();
        this.loadImage(0);

    }

    loadImage(loadIndex, updateImage) {
        const img = new Image();

        let imageLength = updateImage ? updateImage.length : this.imageLength;

        img.src = updateImage ? updateImage[loadIndex].src : this.image[loadIndex].src;

        img.onload = () => {

            this.items.push({
                src: img.src,
                msrc: img.src,
                w: img.width,
                h: img.height,
                title: updateImage ? updateImage[loadIndex].title : this.image[loadIndex].title
            });

            this.imageLoaded = this.imageLoaded + 1;

            if (this.imageLoaded < imageLength) {
                this.loadImage(this.imageLoaded, updateImage);
            } else {

                if (updateImage) {
                    this.image = updateImage;
                }

                this.setView(this.config, updateImage);
                this.setSlide(this.uid - 1, updateImage);
            }

            console.log(img.src);
        };

        img.onerror = () => {
            this.items.push({
                src: img.src,
                msrc: img.src,
                w: 40,
                h: 40,
                title: ''
            });

            this.imageLoaded = this.imageLoaded + 1;

            if (this.imageLoaded < imageLength) {
                this.loadImage(this.imageLoaded, updateImage);
            } else {

                if (updateImage) {
                    this.image = updateImage;
                }

                this.setView(this.config, updateImage);
                this.setSlide(this.uid - 1, updateImage);
            }

            console.log('error', img.src);
        };
    }

    getDelegateTarget(eventTarget, findTarget) {
        let target = $(eventTarget);
        const checkName = (checkNode) => {
            if (!checkNode.is(findTarget)) {
                checkName(checkNode.parent());
            } else {
                target = checkNode;
            }
        };
        checkName(target);
        return target;
    }

    setTemplate(image = this.config.image) {
        $('body').append(viewerTemplate(image));
    }

    setView(config, update) {
        const thumbElements = $(config.btn);

        thumbElements.each(function(index) {
            $(this).data('imageIndex', $(this).attr('data-open-index') ? $(this).attr('data-open-Index') : index);
        });

        if (update) return;

        $(document).on(`click.viewer`, config.btn, (e) => {
            e.preventDefault();
            const target = this.getDelegateTarget(e.target, 'a');
            $(document).off('click.thumbnail');
            this.openViewer(target[0], target.data('imageIndex'), this.uid, update);

            $('body').addClass('viewer--opened');
        });
    }

    openViewer(thumbnail, index, galleryUid, update) {
        const pswpElement = $('.pswp')[galleryUid - 1];
        const config = {
            galleryUID: galleryUid,
            getThumbBoundsFn: function() {
                const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                const rect = thumbnail.getBoundingClientRect();
                return {
                    x: rect.left,
                    y: rect.top + pageYScroll,
                    w: rect.width
                };
            },
            maxSpreadZoom: 1,
            showHideOpacity: true,
            history: false,
            closeOnScroll: false,
            bgOpacity: 0.9,
            timeToIdle: false,
            clickToCloseNonZoomable: false,
            pinchToClose: false,
            index: +index
        };

        this.photoSwipe = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, this.items, config);

        this.photoSwipe.listen('destroy', () => {
            $(document).off('click.thumbnail');
            $(window).trigger('viewer.close');
            $('body').removeClass('viewer--opened');
        });

        this.photoSwipe.listen('afterInit', () => {
            this.DOM_SLIDEBUTTON.removeClass('pswp-navi__thumbnail-link_active');
            this.DOM_SLIDEBUTTON.eq(this.photoSwipe.getCurrentIndex()).addClass('pswp-navi__thumbnail-link_active');
            setTimeout(() => {
                $(window).width() < 641 && this.mobileSlidePosition();
            }, 600);
        });

        this.photoSwipe.listen('imagechangeendwithanimate', () => {
            this.DOM_SLIDEBUTTON.removeClass('pswp-navi__thumbnail-link_active');
            this.DOM_SLIDEBUTTON.eq(this.photoSwipe.getCurrentIndex()).addClass('pswp-navi__thumbnail-link_active');
            this.slide && this.DOM_SLICKSLIDE.slick('slickGoTo', this.photoSwipe.getCurrentIndex());
            this.nowIndex = this.photoSwipe.getCurrentIndex();
            if ($(window).width() > 640) return;
            this.mobileSlidePosition();
        });

        this.photoSwipe.listen('imagechangeend', () => {
            this.DOM_SLIDEBUTTON.removeClass('pswp-navi__thumbnail-link_active');
            this.DOM_SLIDEBUTTON.eq(this.photoSwipe.getCurrentIndex()).addClass('pswp-navi__thumbnail-link_active');
            this.slide && this.DOM_SLICKSLIDE.slick('slickGoTo', this.photoSwipe.getCurrentIndex());
            this.nowIndex = this.photoSwipe.getCurrentIndex();
        });

        this.nowIndex = index;

        this.slide && this.DOM_SLICKSLIDE.slick('slickGoTo', index);

        this.photoSwipe.init();

        $(document).on(`click.thumbnail`, '.pswp-navi__thumbnail-link', (e) => {
            e.preventDefault();
            const target = this.getDelegateTarget(e.target, 'a');
            this.photoSwipe.goTo(target.data('imageIndex'), false);
        });

        $(window).trigger('viewer.open');
    }

    setSlide(index, update) {
        const list = $('.pswp-navi__list');
        this.DOM_SLIDE = list[index];
        this.DOM_SLICKSLIDE = $(this.DOM_SLIDE).find('.scroller');

        if (update) {
            this.slide && this.DOM_SLICKSLIDE.slick('unslick');
            this.slide = false;
            this.DOM_SLICKSLIDE.empty();
            this.DOM_SLICKSLIDE.append(viewerTemplateScroll(this.image));
            this.DOM_SLIDE = list[index];
        }

        this.DOM_SLIDEBUTTON = $(this.DOM_SLIDE).find('.pswp-navi__thumbnail-link');

        this.scrollWidth = this.DOM_SLIDEBUTTON.last().outerWidth(true) * this.DOM_SLIDEBUTTON.length;

        this.DOM_SLIDEBUTTON.each(function(index) {
            $(this).data('imageIndex', index);
        });

        if ($(window).width() > 640) {
            if (this.scrollWidth > $('.pswp-navi__list').width()) {
                this.slide = this.DOM_SLICKSLIDE.slick({
                    infinite: false,
                    slidesToShow: 10,
                    slidesToScroll: 10,
                    variableWidth: true,
                    responsive: [
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 8,
                                slidesToScroll: 8
                            }
                        },
                        {
                            breakpoint: 810,
                            settings: {
                                slidesToShow: 6,
                                slidesToScroll: 6
                            }
                        }
                    ]
                });
            }
        } else {
            if ($(window).width() < 641) {
                $(this.DOM_SLIDE).horizontalBox({
                    'snap': true,
                    'item': '.pswp-navi__thumbnail'
                });
            }
        }

        if (update) return;

        $(this.DOM_SLIDE).on('breakpoint', () => {
            setTimeout(() => {
                this.DOM_SLICKSLIDE.slick('slickGoTo', this.nowIndex);
            }, 600);
        });

        $(window).on(`resize.viewer`, () => {
            this.resize && clearTimeout(this.resize);

            this.resize = setTimeout(() => {
                this.scrollWidth = this.DOM_SLIDEBUTTON.last().outerWidth(true) * this.DOM_SLIDEBUTTON.length;
                this.refreshSlide();
                if ($(window).width() > 640) return;
                this.mobileSlidePosition();
            }, 250);
        });
    }

    refreshSlide() {
        if ($(window).width() > 640) {
            if (this.scrollWidth > $('.pswp-navi__list').width()) {
                if (!this.slide) {
                    this.slide && this.DOM_SLICKSLIDE.slick('unslick');

                    this.slide = this.DOM_SLICKSLIDE.slick({
                        infinite: false,
                        slidesToShow: 10,
                        slidesToScroll: 10,
                        variableWidth: true,
                        responsive: [
                            {
                                breakpoint: 1000,
                                settings: {
                                    slidesToShow: 8,
                                    slidesToScroll: 8
                                }
                            },
                            {
                                breakpoint: 810,
                                settings: {
                                    slidesToShow: 6,
                                    slidesToScroll: 6
                                }
                            }
                        ]
                    });

                    $(this.DOM_SLIDE).trigger('breakpoint');
                }
            }
        } else {
            if ($(window).width() < 641) {
                if (this.scroller) {
                    return;
                }

                this.slide && this.DOM_SLICKSLIDE.slick('unslick');
                this.slide = false;

                $(this.DOM_SLIDE).horizontalBox({
                    'snap': true,
                    'item': '.pswp-navi__thumbnail'
                });
            }
        }
    }

    mobileSlidePosition() {
        if (!$(this.DOM_SLIDE).data('horizontalBox')) return;

        $(this.DOM_SLIDE).data('horizontalBox')._resize();

        if (-65 * this.nowIndex < $(this.DOM_SLIDE).data('horizontalBox').detect.maxScrollX) {
            $(this.DOM_SLIDE).data('horizontalBox')._scrollTo($(this.DOM_SLICKSLIDE), $(this.DOM_SLIDE).data('horizontalBox').detect.maxScrollX, 400);
            $(this.DOM_SLIDE).data('horizontalBox')._resetPosition(400);
        } else {
            $(this.DOM_SLIDE).data('horizontalBox')._scrollTo($(this.DOM_SLICKSLIDE), -65 * this.nowIndex, 400);
            $(this.DOM_SLIDE).data('horizontalBox')._resetPosition(400);
        }
    }

    updateData(image) {
        this.imageLoaded = 0;
        this.items = [];
        this.loadImage(0, image);
    }
}

export default Viewer;
